import { render, staticRenderFns } from "./abstrRegistInfoTab.vue?vue&type=template&id=67a40673&"
import script from "./abstrRegistInfoTab.vue?vue&type=script&lang=js&"
export * from "./abstrRegistInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./abstrRegistInfoTab.vue?vue&type=style&index=0&id=67a40673&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports